<script lang="ts">
  import { Button } from "$ui/button";
  import {
    Root as AlertDialogRoot,
    Content as AlertDialogContent,
    Header as AlertDialogHeader,
    Title as AlertDialogTitle,
    Description as AlertDialogDescription,
    Footer as AlertDialogFooter,
    Cancel as AlertDialogCancel,
  } from "$ui/alert-dialog";
  import { makeApiRequest } from "$utils/api";
  import { selectedTeamStore } from "$stores/teams";

  export let appId: string;
  export let open: boolean = false;

  let isDeleting = false;
  let errorMessage = "";

  const deleteApp = async () => {
    try {
      isDeleting = true;
      await makeApiRequest(`/teams/${$selectedTeamStore?.id}/apps/${appId}`, {}, "DELETE");
      open = false;
    } catch (error: any) {
      errorMessage = "Error deleting App. " + error?.message;
      console.error("Error deleting App:", error);
    } finally {
      isDeleting = false;
    }
  };
</script>

<AlertDialogRoot
  {open}
  closeOnOutsideClick={true}
  onOpenChange={(isOpen) => {
    if (!isOpen) {
      open = false;
    }
  }}
>
  <AlertDialogContent>
    <AlertDialogHeader>
      <AlertDialogTitle>Are You Sure?</AlertDialogTitle>
      <AlertDialogDescription>
        You are about to delete app: <span class="font-medium underline">{appId}</span> and all data and keys associated
        with it.
      </AlertDialogDescription>
    </AlertDialogHeader>
    {#if errorMessage}
      <div class="text-danger-400 text-sm">{errorMessage}</div>
    {/if}
    <AlertDialogFooter>
      <AlertDialogCancel>Cancel</AlertDialogCancel>
      <Button variant="destructive" on:click={deleteApp} disabled={isDeleting}
        >{isDeleting ? "Deleting..." : "Delete App"}</Button
      >
    </AlertDialogFooter>
  </AlertDialogContent>
</AlertDialogRoot>
